import {fabric as Fabric} from 'fabric'

import Base from '../../../Base'
import {startsWith} from '../../../../lib/formatters'

export class Transformer extends Base {
  constructor(data, vm) {
    super(data, vm)
    this.init()
  }
  dropShadow(options = {}, config = {}) {
    const modified = this.$$fabric.set('shadow', options)
    if (config.getObj) {
      return modified
    }
    return modified.toDataURL()
  }
  init(data, vm) {
    data = data || {}
    const parent = this.$$data.$$parent
    const image = data.image || parent.$$loadedImage
    if (image) {
      this.$$fabric = new Fabric.Image(image)
    }
  }

  //@todo
  _init(data, vm) {
    // image detection and loading -refactor and place in separate function, mode parts to transformer
    // add a loading property as a state to identify it's loading
    // can also add a valid property
    if (image) {
      // @todo: Detect if it's src string or dataURI (base64) etc. and load accordingly
      if (_.isString(image)) {
        // base 64
        if (startsWith(image, 'data:')) {
          //
        } else {
          // assume src url - load it
        }
      } else if (_.isObject(image)) {
        // can be html element of fabric-js object or canvas
        const isFabric = image instanceof Fabric.Image
        if (isFabric) {
          this.$fabric = image
        } else {
          // instanceof Node or HTMLElement or HTMLImageElement etc. may not work due to polyfill
          const isImg = image.tagName === 'IMG'
          if (isImg) {
            if (isImg && image.cloneNode) {
              this.$original = image.cloneNode()
            } else {
              this.$original = _.cloneDeep(image)
            }
            this.$fabric = new Fabric.Image(image)
          }
        }
      }
    }

  }
}

export default Transformer
